angular.module( 'acme.view.application.membership.offerings.create.policies.modals.email', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.membership.offerings.create.policies.modals.email.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipOfferingsCreatePoliciesModalsEmail = {
        name: 'application.membership.offerings.create.policies.modals.email',
        url: '/membership/offerings/create/policies/modals/email',
        views: {
          "main": {
            controller: 'MembershipOfferingsCreatePoliciesModalsEmailController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/membership/offerings/create/policies/modals/email/email.tpl.html'
          }
        },
        data: {
          pageTitle: '      ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(membershipOfferingsCreatePoliciesModalsEmail);
});
